import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { OpenJobsState } from 'src/types/open-jobs';
import { getOpenJobs } from './api';

const extraReducers = (builder: ActionReducerMapBuilder<OpenJobsState>): void => {
  builder.addCase(getOpenJobs().pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getOpenJobs().fulfilled, (state, action) => {
    const payload = action?.payload as Record<string, Record<string, unknown>>;
    state.isLoading = false;
    state.data = Object.keys(payload).reduce((acc: Record<string, { label: string; data: number[] }>, key: string) => {
      const subKeyData = payload?.[key]?.data;
      if (Array.isArray(subKeyData)) {
        acc[key] = {
          label: payload?.[key]?.label as string,
          data: subKeyData.map((item: Record<string, unknown>) => item.job_id as number),
        };
      }
      return acc;
    }, {});
    state.source = Object.keys(payload)
      .filter((key) => key !== 'filters') // Exclude filters
      .reduce((acc: Record<number, Record<string, unknown>>, key: string) => {
        const sectionData = payload[key].data as Array<Record<string, unknown>>;
        sectionData.forEach((item) => {
          acc[item.job_id as number] = item;
        });
        return acc;
      }, {}) as OpenJobsState['source'];
  });

  builder.addCase(getOpenJobs().rejected, (state) => {
    state.isLoading = false;
  });
};

export default extraReducers;
